var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogoSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 45,
    viewBox: "0 0 188 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1405_29988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.433 8.87891C15.6713 8.87891 15.0538 9.50162 15.0538 10.2698C15.0538 11.0379 15.6713 11.6607 16.433 11.6607H29.9476C30.7093 11.6607 31.3268 11.0379 31.3268 10.2698C31.3268 9.50162 30.7093 8.87891 29.9476 8.87891H16.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.433 36.8789C15.6713 36.8789 15.0538 36.2562 15.0538 35.488C15.0538 34.7199 15.6713 34.0972 16.433 34.0972H29.9476C30.7093 34.0972 31.3268 34.7199 31.3268 35.488C31.3268 36.2562 30.7093 36.8789 29.9476 36.8789H16.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.398 16.5819C11.398 15.8138 12.0154 15.1911 12.7771 15.1911H26.2918C27.0535 15.1911 27.6709 15.8138 27.6709 16.5819C27.6709 17.3501 27.0535 17.9728 26.2918 17.9728H12.7771C12.0154 17.9728 11.398 17.3501 11.398 16.5819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7771 30.5667C12.0154 30.5667 11.398 29.944 11.398 29.1759C11.398 28.4077 12.0154 27.785 12.7771 27.785H26.2918C27.0535 27.785 27.6709 28.4077 27.6709 29.1759C27.6709 29.944 27.0535 30.5667 26.2918 30.5667H12.7771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01904 22.9197C8.01904 23.6878 8.63651 24.3105 9.3982 24.3105H22.9128C23.6745 24.3105 24.292 23.6878 24.292 22.9197C24.292 22.1515 23.6745 21.5288 22.9128 21.5288H9.3982C8.63651 21.5288 8.01904 22.1515 8.01904 22.9197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.146 12.7587L137.432 32.5053H135.412L133.725 28.4861H124.567L122.88 32.5053H120.86L129.146 12.7587ZM125.349 26.6223L129.146 17.574L132.943 26.6223H125.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9042 32.9779C77.342 32.9779 81.7502 28.5323 81.7502 23.0483C81.7502 17.5643 77.342 13.1186 71.9042 13.1186C66.4664 13.1186 62.0582 17.5643 62.0582 23.0483C62.0582 28.5323 66.4664 32.9779 71.9042 32.9779ZM71.9042 28.5272C74.9046 28.5272 77.3369 26.0742 77.3369 23.0483C77.3369 20.0224 74.9046 17.5694 71.9042 17.5694C68.9038 17.5694 66.4715 20.0224 66.4715 23.0483C66.4715 26.0742 68.9038 28.5272 71.9042 28.5272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3645 13.5326H46.4748V32.574H50.3645V24.6908L57.1908 32.574H62.1518L53.9075 23.0533L62.1518 13.5326H57.1908L50.3645 21.4159V13.5326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4392 13.5326H89.3289V28.9523H96.5392V32.574H85.4397L85.4392 13.5326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.146 32.8554C117.015 32.8554 117.719 32.1454 117.719 31.2695C117.719 30.3936 117.015 29.6836 116.146 29.6836C115.278 29.6836 114.574 30.3936 114.574 31.2695C114.574 32.1454 115.278 32.8554 116.146 32.8554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.13 32.5053L170.844 12.7587L162.558 32.5053H164.578L166.265 28.4861H175.423L177.11 32.5053H179.13ZM170.844 17.574L167.047 26.6223H174.641L170.844 17.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.286 13.5326H158.256V32.5053H156.286V13.5326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.062 16.9482L107.686 18.5318C107.136 16.7091 104.358 15.6917 103.04 17.3939C101.81 19.3627 103.699 20.5631 106.966 21.7849C110.169 22.983 111.37 24.904 111.434 27.1082C111.497 29.3124 110.276 33.0414 104.653 32.9986C100.155 32.9644 98.2659 29.9455 97.8839 28.4404C98.4144 28.1907 99.8404 27.5373 101.3 26.921C102.489 30.5804 107.242 30.1738 107.56 27.7342C107.802 25.882 105.896 25.1833 104.056 24.509C103.374 24.2589 102.7 24.012 102.149 23.711C99.7026 22.3746 99.0243 20.7317 98.8814 19.0885C98.7384 17.4453 99.2641 13.8911 104.271 13.1794C108.183 12.6234 110.489 15.4255 111.062 16.9482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.819 16.9328L150.657 16.0461C149.901 14.3793 147.802 12.9112 145.16 13.2925C141.191 13.8653 140.667 17.1824 140.788 18.8153C140.91 20.4481 141.595 21.7391 143.823 22.9883C144.235 23.2193 144.753 23.4338 145.306 23.663C147.163 24.4323 149.419 25.3672 149.419 27.6463C149.419 31.9263 142.989 31.8677 141.977 28.2313C141.394 28.5184 141.051 28.6793 140.806 28.7947C140.527 28.9256 140.373 28.9982 140.132 29.13C140.458 30.6257 142.382 32.8322 145.629 32.8322C150.191 32.8322 151.36 29.6348 151.306 27.4445C151.252 25.2542 150.005 23.7343 147.275 22.5438L147.087 22.4617C144.386 21.2856 142.147 20.3106 142.873 17.2395C143.489 14.635 147.727 14.3634 148.819 16.9328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1405_29988",
    x: 0.019043,
    y: 0.878906,
    width: 187.111,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1405_29988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1405_29988",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoSvg);
export default __webpack_public_path__ + "static/media/nav_logo_svg.e2fff8eab5a9974002f921e2c8d5bf7b.svg";
export { ForwardRef as ReactComponent };